import TournamentResults from './TournamentResult';

export default TournamentResults;
